import { CircleDashedIcon } from 'lucide-react';

import { Badge } from '@/components/ui/badge';

const UnclaimedBadge = () => (
  <Badge className="gap-1 rounded-full bg-amber-100 py-1 text-2xs text-amber-800 border-amber-200 tracking-[0.02em]">
    <CircleDashedIcon className="size-3 shrink-0" />
    Untitled Application
  </Badge>
);

export { UnclaimedBadge };
